// extracted by mini-css-extract-plugin
export default {"root":"_2NV4CR3z","slideDown":"_3zuNj_GH","animated":"_2dn2HwUt"};